import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Signup from './views/Signup.vue'
import ConfirmPassword from './views/ConfirmPassword.vue'
import Code from './views/Code.vue'
import Login from './views/Login.vue'
import VideosCapacitacion from './views/VideosCapacitacion.vue'
import Manuales from './views/Manuales.vue'
import Planeaciones1k from './views/Planeaciones1k.vue'
import Planeaciones2k from './views/Planeaciones2k.vue'
import Planeaciones3k from './views/Planeaciones3k.vue'
import PlaneacionesOnu from './views/PlaneacionesOnu.vue'
import ChangePassword from './views/ChangePassword.vue'
import Videos from './views/Videos.vue'
import Canciones from './views/Canciones.vue'
import Cuentos from './views/Cuentos.vue'
import Dibujos from './views/Dibujos.vue'
import Actividades from './views/Actividades.vue'
import Principal from './views/Principal.vue'
import Coreografias from './views/Coreografias.vue'
import Kits from './views/Kits.vue'
import Libros from './views/Libros.vue'
import LalabumExplica from './views/LalabumExplica.vue'
import FondosVirtuales from './views/FondosVirtuales.vue'

import ResetPassword from './views/ResetPassword.vue'
import axios from 'axios'


Vue.use(Router)
let router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [ 
    {
      path: '/',
      name: 'principal',
      component: Principal,
      meta:{login:true}
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta:{login:true}
    },
    {
      path: '/confirm_password',
      name: 'confirm_password',
      component: ConfirmPassword,
      meta:{login:true}
    },
    {
      path: '/code',
      name: 'code',
      component: Code,
      meta:{login:true}
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta:{login:true}
    },
    {
      path: '/videos_capacitacion',
      name: 'videos_capacitacion',
      component: VideosCapacitacion,
      meta: { requiresAuth: true }
    }
    ,
    {
      path: '/manuales',
      name: 'manuales',
      component: Manuales,
      meta: { requiresAuth: true }
    },
    {
      path: '/planeaciones_onu',
      name: 'planeaciones_onu',
      component: PlaneacionesOnu,
      meta: { requiresAuth: true }
    },
    {
      path: '/planeaciones1k',
      name: 'planeaciones1k',
      component: Planeaciones1k,
      meta: { requiresAuth: true }
    },
    {
      path: '/planeaciones2k',
      name: 'planeaciones2k',
      component: Planeaciones2k,
      meta: { requiresAuth: true }
    },
    {
      path: '/planeaciones3k',
      name: 'planeaciones3k',
      component: Planeaciones3k,
      meta: { requiresAuth: true }
    },
    {
      path: '/changepassword',
      name: 'changepassword',
      component: ChangePassword,
      meta: { requiresAuth: true }
    }
    ,
    {
      path: '/videos',
      name: 'videos',
      component: Videos,
      meta: { requiresAuth: true }
    },
    
    {
      path: '/canciones',
      name: 'canciones',
      component: Canciones,
      meta: { requiresAuth: true }
    },
    {
      path: '/cuentos',
      name: 'cuentos',
      component: Cuentos,
      meta: { requiresAuth: true }
    },
    {
      path: '/dibujos',
      name: 'dibujos',
      component: Dibujos,
      meta: { requiresAuth: true }
    },
    {
      path: '/kits',
      name: 'kits',
      component: Kits,
      meta: { requiresAuth: true }
    },     
    {
      path: '/libros',
      name: 'libros',
      component: Libros,
      meta: { requiresAuth: true }
    }, 
    {
      path: '/actividades',
      name: 'actividades',
      component: Actividades,
      meta: { requiresAuth: true }
    },
    {
      path: '/lalabumexplica',
      name: 'lalabumexplica',
      component: LalabumExplica,
      meta: { requiresAuth: true }
    },
    {
      path: '/coreografias',
      name: 'coreografias',
      component: Coreografias,
      meta: { requiresAuth: true }
    },
    {
      path: '/fondosvirtuales',
      name: 'fondosvistuales',
      component: FondosVirtuales,
      meta: { requiresAuth: true }
    }, 
    {
      path: '/reset_password',
      name: 'restablecer',
      component: ResetPassword,
      meta:{login:true}    
    }
   
  ]
})

router.beforeEach((to,from,next)=>{
  if (to.matched.some(record=>record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      let token  = localStorage.getItem('token')      
      const AuthStr = 'Bearer '.concat(token);
      axios.get("https://Lalabumapp.com:4443/RefreshToken",{ headers: { Authorization: AuthStr } })
      .then(resp =>{                
        if(resp.status=="200"){
          const refreshtoken = resp.data.data.token  
          localStorage.setItem('token', refreshtoken)
          next()
        } else {
          localStorage.setItem('token', '')
          next('/login')
        }})
      .catch(() => {
        
        next('/login')
      });
    }else{
    next('/login')
  }
  }else if(to.matched.some(record=>record.meta.login)){
    next()     
  }
});

export default router